function SickDaysRulesMixin () {}
SickDaysRulesMixin.prototype.cellGeneralClassName = "sickDaysRulesCell";
SickDaysRulesMixin.prototype.getBalanceFromCellValue = function( value ) {
    return value.currentSickDaysBalance;
};

export default SickDaysRulesMixin



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/SickDaysRulesMixin.js